export default __webpack_public_path__ + "static/media/ogannasson.93198334.png";